<template>
  <div class="container flex flex-x-center">
    <div class="flex space-between flex-y-center nav-container">
      <img src="../assets/images/logo.png">
      <ul class="nav-list flex space-between">
        <li v-for="(item,index) in navList" :key="index" @click="handleJump(item)" class="curPointer" :class="item.active == true ? 'active' : ''">
          <span>{{item.name}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'headerNav',
  data () {
    return {
      navList:[
        { name:'首页', path:'/',active:false },
        { name:'热点资讯', path:'/hotDynamic',active:false },
        { name:'专家智库', path:'/expertsLibrary',active:false },
        { name:'商学院', path:'/businessCollege',active:false },
        { name:'小院士', path:'/studentCollege',active:false },
        { name:'职业技术培训', path:'/adultEducation',active:false },
        { name:'关于我们', path:'/aboutUs',active:false },
      ],
      currentPath:'',//当前路由
    }
  },
  watch:{
    $route(to,from){
      this.currentPath = to.path
      this.navList.map(res=>{
        res.active = res.path == to.meta.parent
      })
    }
  },
  methods:{
    handleJump(item){
      if(this.currentPath == item.path) return
      this.$router.push({path:item.path})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@media screen and (max-width: 1400px) {
  .nav-container{
    min-width:1000px !important;
  }
}
.container{
  width: 100%;
  height: 100px;
  box-shadow: 0px 4px 27px 0px rgba(0, 15, 47, 0.1);
  position: fixed;
  top: 0;
  background-color: #ffffff;
  z-index: 999;
  .nav-container{
    min-width:1400px;
    img{
      width: 198px;
      height: 53px;
    }
    .nav-list{
      width: calc(100% - 198px - 150px);
      margin-left: 150px;
      li{
        list-style: none;
        font-size: 16px;
        position: relative;
        padding-bottom: 5px;
      }
      .active{
        border-bottom: 3px solid #15A364;
        span{
          color: #15A364;
        }
      }
      li:hover{
        span{
          color: #15A364;
        }
      }
    }
  }
}
@media screen and (max-width: 1600px ) and (min-width:1200px) {
  .nav-container{
    min-width:1200px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headerNav.vue